// 修正路径：添加lang层级（适配旧版本Element Plus）
import zhCn from '@element-plus/locale/lang/zh-cn';
import en from '@element-plus/locale/lang/en';
import ja from '@element-plus/locale/lang/ja';
import ko from '@element-plus/locale/lang/ko';
import fr from '@element-plus/locale/lang/fr';

// 为配置表添加明确类型（避免TS7053错误）
interface LangConfigItem {
  elementLocale: any; // 实际项目中可替换为具体类型
  dayjsLocale: string;
}

// 语言映射表（带类型约束）
export const langConfig: Record<string, LangConfigItem> = {
  'zh-CN': {
    elementLocale: zhCn,
    dayjsLocale: 'zh-cn',
  },
  'en-US': {
    elementLocale: en,
    dayjsLocale: 'en',
  },
  'ja-JP': {
    elementLocale: ja,
    dayjsLocale: 'ja',
  },
  'ko-KR': {
    elementLocale: ko,
    dayjsLocale: 'ko',
  },
  'fr-FR': {
    elementLocale: fr,
    dayjsLocale: 'fr',
  },
};

export const supportedLangs = Object.keys(langConfig);